import one from '../assets/svg/projects/one.svg'
import two from '../assets/svg/projects/two.svg'
import perawat from '../assets/svg/projects/perawat.svg'
import four from '../assets/svg/projects/four.svg'
import five from '../assets/svg/projects/five.svg'
import six from '../assets/svg/projects/six.svg'
import seven from '../assets/svg/projects/seven.svg'
import eight from '../assets/svg/projects/eight.svg'


export const projectsData = [
    {
        id: 1,
        projectName: 'Ethan Shop',
        projectDesc: 'Aplikasi Mobile App bergerak di bidang kesehatan, pendidikan dan e-Commerce',
        tags: ['Kesehatan', 'Pendidikan', 'E-Commerce'],
        code: 'https://play.google.com/store/apps/details?id=com.itenshop',
        demo: 'https://ethan-shop.netlify.app',
        image: one
    },
    {
        id: 2,
        projectName: 'Alo Care Mobile App',
        projectDesc: 'Chat dan Layanan Online.',
        tags: ['Chat', 'Fintech'],
        code: 'https://play.google.com/store/apps/details?id=com.aloocare.alocare',
        demo: 'https://play.google.com/store/apps/details?id=com.aloocare.alocare',
        image: two
    },
    {
        id: 3,
        projectName: 'Perawat Mobile App',
        projectDesc: 'Aplikasi mencatat pasien, Diagnosa dll, menghitung dosis obat, dan pencarian obat',
        tags: ['Os Note', 'IMT Calculate', 'Drug Calculate'],
        code: 'https://play.google.com/store/apps/details?id=com.perawat',
        demo: 'https://play.google.com/store/apps/details?id=com.perawat',
        image: perawat
    },
    {
        id: 4,
        projectName: 'Karawang Info Mobile App',
        projectDesc: 'Informasi seputar kota Karawang',
        tags: ['Informasi', 'Layanan Jasa area kota Karawang'],
        code: 'https://play.google.com/store/apps/details?id=com.karawanginfo',
        demo: 'https://play.google.com/store/apps/details?id=com.karawanginfo',
        image: four
    },
    {
        id: 5,
        projectName: 'Sehat Mobile App',
        projectDesc: 'Drug Referensi, Data Penting Saver',
        tags: ['Drug Search', 'Image Saver'],
        code: 'https://play.google.com/store/apps/details?id=com.sehat.bayukarta',
        demo: 'https://play.google.com/store/apps/details?id=com.sehat.bayukarta',
        image: five
    },
    {
        id: 6,
        projectName: 'Hospital Mobile App',
        projectDesc: 'Register Pasien, Make Appoitment',
        tags: ['Monitoring Antrian'],
        code: 'https://wa.me/+62895600394345',
        demo: 'https://wa.me/+62895600394345',
        image: six
    },
    {
        id: 7,
        projectName: 'Webstite Portofolio',
        projectDesc: 'Personal Brand via Webiste',
        tags: ['React', 'Redux', 'Bootstrap'],
        code: 'https://ekosetiaji.netlify.app',
        demo: 'https://ekosetiaji.netlify.app',
        image: seven
    },
    {
        id: 8,
        projectName: 'Company Website',
        projectDesc: 'Company Profile via Website',
        tags: ['Flutter', 'React'],
        code: 'https://ethan-shop.netlify.app',
        demo: 'https://ethan-shop.netlify.app',
        image: one
    },
]


// Do not remove any fields.
// Leave it blank instead as shown below

/* 
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
}, 
*/